function getConfig() {
  return {
    serverRuntimeConfig: {
      graphqlURL: process.env.LISTING_ENGINE_GRAPH_URL
        ? new URL(process.env.LISTING_ENGINE_GRAPH_URL)
        : undefined,
      recaptchaSecretKey: process.env.RECAPTCHA_SECRET_KEY,
      facebook: {
        accessToken: process.env.FACEBOOK_ACCESS_TOKEN,
      },
      sanity: {
        token: process.env.SANITY_API_READ_TOKEN!,
      },
    },
    publicRuntimeConfig: {
      canonicalUrl: new URL(process.env.NEXT_PUBLIC_CANONICAL_URL!),
      sanity: {
        projectId: process.env.NEXT_PUBLIC_SANITY_PROJECT_ID!,
        dataset: process.env.NEXT_PUBLIC_SANITY_DATASET!,
        apiVersion: process.env.NEXT_PUBLIC_SANITY_API_VERSION || '2024-01-01',
      },
      aws: {
        uploadBucket: process.env.NEXT_PUBLIC_S3_UPLOAD_BUCKET!,
      },
      apple: {
        clientId: process.env.NEXT_PUBLIC_APPLE_CLIENT_ID!,
      },
      facebook: {
        appId: process.env.NEXT_PUBLIC_FACEBOOK_APP_ID!,
      },
      google: {
        apiKey: process.env.NEXT_PUBLIC_GOOGLE_API_KEY!,
        clientId: process.env.NEXT_PUBLIC_GOOGLE_CLIENT_ID!,
      },
      imagekitEndpoint: process.env.NEXT_PUBLIC_IMAGEKIT_ENDPOINT!,
      graphqlProxyPath: '/api/graphql/',
      stripe: {
        giftCardPublicKey: process.env.NEXT_PUBLIC_STRIPE_GIFT_CARD_PUBLIC_KEY!,
        publicKey: process.env.NEXT_PUBLIC_STRIPE_PUBLIC_KEY!,
        subscriptionProducts: {
          freeMonthly: {
            id: process.env.NEXT_PUBLIC_STRIPE_FREE_MONTHLY_PLAN_ID!,
          },
          bronzeMonthly: {
            id: process.env.NEXT_PUBLIC_STRIPE_BRONZE_MONTHLY_PLAN_ID!,
          },
          silverMonthly: {
            id: process.env.NEXT_PUBLIC_STRIPE_SILVER_MONTHLY_PLAN_ID!,
          },
          goldMonthly: {
            id: process.env.NEXT_PUBLIC_STRIPE_GOLD_MONTHLY_PLAN_ID!,
          },
          privateMonthly: {
            id: process.env.NEXT_PUBLIC_STRIPE_PRIVATE_MONTHLY_PLAN_ID!,
          },
        },
        payPerReservationPromoCode:
          process.env.NEXT_PUBLIC_STRIPE_PAY_PER_RESERVATION_PROMO_CODE!,
      },
      recaptchaSiteKey: process.env.NEXT_PUBLIC_RECAPTCHA_SITE_KEY!,
    },
  };
}

export default getConfig;
